import { formatNumber, utils } from '@/helpers';
import { CoMarketingBudget, InstalledCoMarketingTemplate, SponsoredCoMarketingTemplate } from '@/types';

export function getCoMarketingBudgetForUser(template: SponsoredCoMarketingTemplate | InstalledCoMarketingTemplate, userID: string) {
	if (!template.isPaid) {
		return 'Not Paid';
	}

	if (template.budgetMethod === 'fixed') {
		return `$${formatNumber(template.budgetByUID?.[userID] ?? 0)}`;
	}

	if (template.budgetMethod === 'split') {
		return `${((template.splitCostPercentage ?? 0) * 100).toFixed(2)}% covered`.replaceAll('.00', '');
	}

	return 0;
}

export function getCoMarketingBudget(template?: Partial<SponsoredCoMarketingTemplate | InstalledCoMarketingTemplate>, uid?: string): Partial<CoMarketingBudget> {
	const budgetByUID: Record<string, number> = {};
	if (uid && template?.budgetByUID?.[uid]) {
		budgetByUID[uid] = template.budgetByUID[uid];
	}

	return {
		allowContinuedSending: template?.allowContinuedSending,
		isPaid: template?.isPaid,
		requiresApproval: template?.requiresApproval,
		budgetMethod: template?.budgetMethod,
		budgetByUID,
		splitCostPercentage: template?.splitCostPercentage,
	};
}
